import { createAliasScope, type AliasScope } from '../ids/aliasScope.js';
import type { GraphNode } from './nodeDefs.js';

export function formatStableIdDebugLabel(id: string): string {
  const underscoreIndex = id.indexOf('_');
  if (underscoreIndex < 0) return id;
  const prefix = id.slice(0, underscoreIndex + 1);
  const rest = id.slice(underscoreIndex + 1);
  return rest.length <= 8 ? id : `${prefix}${rest.slice(0, 8)}…`;
}

export function createGraphDebugAliasScope(sortedIds: string[], nodes: GraphNode[]): AliasScope {
  const remainingIds = nodes
    .map(node => node.id)
    .filter(id => !sortedIds.includes(id))
    .sort((left, right) => left.localeCompare(right));

  return createAliasScope('n', [...sortedIds, ...remainingIds]);
}

export function formatNodeDebugLabel(node: GraphNode, aliases: AliasScope): string {
  return `${aliases.get(node.id)} · ${node.type} · ${formatStableIdDebugLabel(node.id)}`;
}

export function formatNodeIdDebugLabel(nodeId: string, nodeMap: Record<string, GraphNode>, aliases: AliasScope): string {
  const node = nodeMap[nodeId];
  if (!node) return formatStableIdDebugLabel(nodeId);
  return formatNodeDebugLabel(node, aliases);
}

export function formatGraphIssueMessage(
  message: string,
  nodeIds: string[],
  nodeMap: Record<string, GraphNode>,
  aliases: AliasScope,
): string {
  if (nodeIds.length === 0) return message;
  const labels = [...new Set(nodeIds.map(nodeId => formatNodeIdDebugLabel(nodeId, nodeMap, aliases)))];
  return `${message} [${labels.join(', ')}]`;
}
